import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Servicios', to: '/servicios' },
  { label: 'Diagnóstico', to: '/diagnostico-gratuito' },
  { label: 'Contacto', to: '/contacto' },
];

const MainframeNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-10 flex items-center justify-between px-5 sm:px-8 py-4 sm:py-5 bg-white/85 backdrop-blur-md border-b border-black/5">
        <Link to="/" className="flex items-center" aria-label="Orbiax, ir al inicio">
          <img src="/assets/logo-orbiax.webp" alt="Orbiax" width="339" height="88" className="h-9 sm:h-11 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center text-[23px] text-black">
          {NAV_LINKS.map((link, i) => (
            <span key={link.to} className="flex items-center">
              <Link to={link.to} className="hover:opacity-60 transition-opacity">
                {link.label}
              </Link>
              {i < NAV_LINKS.length - 1 && <span>,&nbsp;</span>}
            </span>
          ))}
        </nav>

        <Link
          to="/diagnostico-gratuito"
          className="hidden md:inline-flex items-center bg-black text-white text-[15px] font-medium px-6 py-3 rounded-full hover:opacity-80 transition-opacity"
        >
          Consulta Gratis
        </Link>

        <button
          onClick={() => setIsOpen((v) => !v)}
          aria-label="Menú"
          className="md:hidden flex flex-col gap-[5px] p-2"
        >
          <span
            className="w-6 h-[2px] bg-black transition-transform duration-300"
            style={{ transform: isOpen ? 'translateY(7px) rotate(45deg)' : 'none' }}
          />
          <span className="w-6 h-[2px] bg-black transition-opacity duration-300" style={{ opacity: isOpen ? 0 : 1 }} />
          <span
            className="w-6 h-[2px] bg-black transition-transform duration-300"
            style={{ transform: isOpen ? 'translateY(-7px) rotate(-45deg)' : 'none' }}
          />
        </button>
      </header>

      <div
        className="md:hidden fixed inset-0 z-[9] bg-white/95 backdrop-blur-sm flex flex-col justify-center items-start px-8 gap-8 transition-opacity duration-300"
        style={{ opacity: isOpen ? 1 : 0, pointerEvents: isOpen ? 'auto' : 'none' }}
      >
        {NAV_LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            onClick={() => setIsOpen(false)}
            className="text-[32px] font-medium text-black"
          >
            {link.label}
          </Link>
        ))}
        <Link
          to="/diagnostico-gratuito"
          onClick={() => setIsOpen(false)}
          className="inline-flex items-center bg-black text-white text-[18px] font-medium px-6 py-3 rounded-full"
        >
          Consulta Gratis
        </Link>
      </div>
    </>
  );
};

export default MainframeNavbar;
